module.exports = __webpack_public_path__ + "static/media/renewables.cd8a7937.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/renewables.svg
// module id = 296
// module chunks = 0